import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../components/Hero";
import About from "../components/About";
import FeaturedDishes from "../components/FeaturedDishes";
import Gallery from "../components/Gallery";
import OpeningHours from "../components/OpeningHours";
import Reviews from "../components/Reviews";
import Contact from "../components/Contact";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 300);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <>
      <Hero />
      <About />
      <FeaturedDishes />
      <Gallery />
      <OpeningHours />
      <Reviews />
      <Contact />
    </>
  );
}
